<template>
  <div>
    <div class="content" >
      <div class="right-sty">
        <div class="left-span">
          <div>
              <span>活动名{{ name }}：</span>
            
          </div>
          <div
            :class="type == 0 ? 'type-Sty end-sty' : 'type-Sty ing-sty'"
          >
            {{ type == 0 ? "进行中" : type==1?"已开奖":"已参与" }}
          </div>
        </div>
        <div class="left-time">{{time}}开奖</div>
      </div>
    </div>
    <div v-if="this.type != 1">
      <div class="lottery-sty">
        <div class="check-sty" @click.prevent="isChecked">
          {{ type == 0 ? "参加抽奖" :"分享好友" }}
        </div>
      </div>
    </div>
    <div class="details-con" v-if="this.type==1">
      <div :class="this.code == 1&this.iswin==1 ? 'con-tit con-tit2' : 'con-tit'">
        {{ this.code == 0 ? " 您来晚了，已经开奖啦！" :this.iswin==1? "恭喜您中奖了！！":"谢谢参与" }}
      </div>
      <div v-if="this.code == 1&this.iswin==1">
        <div class="address-sty" @click="addAddress">请填写收货地址</div>
        <div class="note-sty">
          请在<span>30天</span
          >内填写，逾期发起者不再接受发货申请。避免收寄问题请如实填写真实姓名。
        </div>
      </div>
      <div class="con-list">中奖者名单</div>
      <div style="border: 1px solid #dcdfe6" v-for="(item, index) in dataList" :key="index" >
        <div class="con-text text-tit">奖品：{{item.name}}</div>
        <div class="lottery-img">
          <div class="lottery-img " v-for="(a, index) in item.value" :key="index">
          <div class="img-img0" >
            <img class="img-sty" :src="a.headimgurl" alt="头像" />
            <div class="con-text">{{a.nickname}}</div>
          </div>
        </div>
        </div>
      </div>
    </div>
    <div class="lottery-sty">

      <div class="number-all">已经有 <span>{{list.length}}</span>人参与</div>
      <div class="lottery-img">
        <div class="num-img" v-for="(a, index) in list.slice(0,9)" :key="index" >
        <img class="img-sty" :src="a.headimgurl" alt="" />
      </div>

      </div>
    </div>
    <van-overlay :show="showImg" @click="isShowImg">
      <div class="wrapper">
       <img style="width:100%" src='./../assets/img/showImg.png' alt="">
      </div>
    </van-overlay>
  </div>
</template>
<script>
import URL from "@/api/api";
import { getShareInfo} from '@/utils/utils';
import { ImagePreview, Toast } from 'vant';
export default {
   components: {
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  data() {
    return {
      participate: "参与抽奖",
      code: 1,
      id: 1,
      title: "这是抽奖呀！",
      lottery: [{ name: "吹风机", number: 2 }],
      userList:[{}],
      type: 0,
      dataList:[],
      list:[],
      openid:'',
      name:'',
      nickName:'',
      headUrl:'',
      info:'',
      time:'',
      iswin:'',
      showImg:false
    };
  },
    created(){this.createdata()},
  mounted() {this.fetchData();
    this.getUser();
  },
  methods: {
    isShowImg(){
      this.showImg=false
    },
    getWxShare(){
      // const url=this.commonUrl.F_URL
      const url=process.env.VUE_APP_BASE_URL
      let data={
        geturl:`/activities/card/signInfo?url=${url}`,
        typeId:this.id,
        shareImg:'https://dtfcloud.com/share-pic/lottery.jpg',
        titleData:this.name,
        qaDesc:this.info,
        // linkUrl:this.commonUrl.SHARE_LOT
        linkUrl:process.env.VUE_APP_BASE_URL+ '#/lotteryDetails/details?show=1&id='
      }
      getShareInfo(data)
    },
    createdata(){
      this.id=this.$route.query.id;
       var o=localStorage.getItem("openid");
      if(!o){
        o=this.$route.query.openid;
      }
     
      this.openid=o
      if(!this.openid){
        // this.commonUrl.F_URL
        this.$fetchGet(URL.wx.url,{frontUrl:process.env.VUE_APP_BASE_URL,channel:"ZFKJ",param:"/lotteryDetails/details?id="+this.id+"&openid=%s"}).then(res=>{
           if (res.data.code == 20000) {
            window.location.href = res.data.data
          }
        })
      }
    },
    getUser(){
      this.$fetchPost(URL.getUser.url,{openId:this.openid,channel:"ZFKJ"}).then(res=>{
      this.nickName= res.data.data.nickName;
      this.headUrl=res.data.data.avatarName;
     })
    },
    fetchData(){
      //this.type=this.$route.query.status;
     
      
    this.$fetchGet(URL.getuserlist.url,{openid:this.openid,batchId:this.id}).then(res=>{
      this.iswin=res.data.data.iswin;
      this.userList=res.data.data.userlist;
      this.code=res.data.data.type;
      this.dataList=res.data.data.res
      this.type=res.data.data.batchInfo.status;
      this.name=res.data.data.batchInfo.name;
      this.info=res.data.data.batchInfo.info;
      this.time=res.data.data.batchInfo.time;
      this.list=res.data.data.userlist;
      if(this.type==0){
          if(res.data.data.type==1){
              this.type=2
          }
      }
    
       this.getWxShare()
    })
    },
    isChecked() {
      var data
      if(this.type==0){
        if(!localStorage.getItem("nickname")||!localStorage.getItem("headurl")){
             data={
          
          openId:this.openid,
          nickName:this.nickName,
         
          batchId:this.id,
          headUrl:this.headUrl 
          
        }
        }else{
           data={
          
          openId:localStorage.getItem("openid"),
          nickName:localStorage.getItem("nickname"),
          //   openId:"oWbEe411P4C1lLZZcYd19Y815i7k",
          // nickName:"测试nickname",
          batchId:this.id,
          headUrl:localStorage.getItem("headimgurl") 
          // headUrl:"测试url"
        }
        }
       
        this.$fetchPost(URL.lottery.url,data).then(res=>{
            location.reload();
        })
      }else{
        this.showImg=true
        // Toast("请点击右上角分享")
      }
    },
    addAddress(){
         this.$router.push({path:'/addressEdit/details',query:{batchid:this.id}});
    }
  },
};
</script>
<style scoped>
.content {
  /* width: 95%; */
  margin: 10px auto;
  padding: 10px;
  line-height: 35px;
  background: #fff;
  border-radius: 5px;
}
.left-span {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
}
.span-num {
  padding-left: 10px;
  color: #909399;
}
.left-time {
  font-size: 14px;
  color: #909399;
}
.end-sty {
  color: #1989fa;
}
.ing-sty {
  color: red;
}

/* demo */
.lottery-sty {
  padding: 20px 20px;
  background: #fff;
}
.check-sty {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: #b72424;
  font-size: 16px;
  text-align: center;
  line-height: 100px;
  color: #fff;
  margin: auto;
}
.number-all {
  flex-wrap: wrap;
  text-align: center;
  font-size: 14px;
  color: #646566;
}
.lottery-img{
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.num-img {
  text-align: center;
}
.img-sty {
  width: 25px;
  border-radius: 50%;
}
.img-img0{
  text-align:center;
  margin:0 10px;
}
/* 开奖后 */
.details-con {
  padding: 10px;
  margin-bottom: 15px;
  background: #fff;
}
.con-tit {
  padding-top: 15px;
  font-size: 22px;
  font-weight: bold;
}
.con-tit2 {
  color: #f30707;
}
.con-list {
  padding: 25px 0;
  font-size: 17px;
}
.con-text {
  text-align: center;
  padding-bottom: 11px;
  font-size: 17px;
  /* border: 1px solid; */
}
.text-tit {
  padding: 15px 0;
  background: #f7f8fa;
}
/* 收货地址 */
.address-sty {
  width: 95%;
  height: 120px;
  margin: 25px auto;
  border-radius: 5px;
  background: #f06445;
  text-align: center;
  line-height: 120px;
  font-size: 16px;
  color: yellow;
}
.note-sty {
  font-size: 15px;
  line-height: 1.5em;
}
.note-sty span {
  color: #f30707;
}
.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    width: 100%;
    height: 100%;
    background-color: #fff;
  }
  .van-overlay{
    background-color: rgba(0,0,0,.4);
  }
</style>